import { Button, Card, Heading, Inline, Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { Overlay } from '@eti/components';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import ContactMethods from '../../../../common/components/ContactMethods';
import FormCheckbox from '../../../../common/components/formComponents/formCheckbox/FormCheckbox';
import { isRequired } from '../../../../common/components/formComponents/validations';
import CancellationPnrCard from './cancellation/CancellationPnrCard';

const MultiPnrRefundRequest = () => {
  const { t } = useTranslation();
  const { flightInformation } = useOrderDetails();
  const [isContactUsDrawerOpen, setIsContactUsDrawerOpen] = useState(false);

  const methods = useForm<{ consent: boolean }>({
    defaultValues: { consent: false },
  });

  const { handleSubmit } = methods;

  return (
    <>
      <Card data-testid="refund-request-multi-pnr">
        <Stack>
          <Stack spacing={8}>
            <Heading level={2}>{t('ManageTrip.RefundRequest.Title')}</Heading>
            <Text>{t('ManageTrip.RefundRequest.MultiPnr.Description')}</Text>
          </Stack>
          {flightInformation.map((flight) => (
            <CancellationPnrCard key={flight.pnr} providerBooking={flight} />
          ))}
          <FormProvider {...methods}>
            <form noValidate onSubmit={handleSubmit(() => setIsContactUsDrawerOpen(true))}>
              <Inline align="end" alignY="center" spacing={8}>
                <FormCheckbox
                  data-testid="request-refund-consent-checkbox"
                  isRequired
                  label={t('ManageTrip.RefundRequest.ConsentCheckbox.Label')}
                  name="consent"
                  validations={isRequired(t('ManageTrip.RefundRequest.ConsentCheckbox.Error.Text'))}
                />
                <Button
                  aria-controls="contact-us-drawer"
                  aria-expanded={isContactUsDrawerOpen ? 'true' : 'false'}
                  aria-haspopup="dialog"
                  data-testid="contact-us-button"
                  type="submit"
                  variant="primary"
                >
                  {t('OrderDetails.Tab.ContactUs.Description')}
                </Button>
              </Inline>
            </form>
          </FormProvider>
        </Stack>
      </Card>
      <Overlay.Drawer
        dataTestId="contact-us-drawer"
        handleClose={() => setIsContactUsDrawerOpen(false)}
        id="contact-us-drawer"
        isOpen={isContactUsDrawerOpen}
      >
        <Overlay.Header
          onClose={() => setIsContactUsDrawerOpen(false)}
          title={t('OrderDetails.Tab.ContactUs.Description')}
        />
        <Overlay.Content data-testid="contact-us-drawer-content">
          <Card>
            <ContactMethods chatType="genesys" isCallExpanded />
          </Card>
        </Overlay.Content>
      </Overlay.Drawer>
    </>
  );
};

export default MultiPnrRefundRequest;
